// extracted by mini-css-extract-plugin
export default {"loading_btn":"style_loading_btn__WMuGc","btn_loader":"style_btn_loader__tpTyG","spin":"style_spin__o7ixb"};